import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue'
import { deepCopy } from '../utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditColumnTableColDlg',
  props: {
  column: {
    type: Object,
    required: true
  },
  modelValue: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const visible = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emits('update:modelValue', val)
})

// 编辑中的列数据副本，点击“确定”后才写回
const editingColumn = ref(deepCopy(props.column))

// 确定：将编辑结果写回原列
const onOk = () => {
  // eslint-disable-next-line vue/no-mutating-props
  Object.assign(props.column, editingColumn.value)
  emits('update:modelValue', false)
}

// 取消：不保存，直接关闭
const onCancel = () => {
  emits('update:modelValue', false)
}

// 弹窗标题
const title = computed(() => `编辑[${(props.column as { label?: string }).label || ''}]列属性`)

// 列类型
const columType = [
  {
    value: 'normal',
    label: '普通列'
  },
  {
    value: 'expand',
    label: '展开列'
  },
  {
    value: 'action',
    label: '功能列'
  },
  {
    value: 'link',
    label: '链接'
  }
]

// 查询区/添加/编辑的组件类型
const tagDefinedList = [
  {
    value: 'el-input',
    label: '文本框'
  },
  {
    value: 'DropDownSelector',
    label: '下来选择器'
  },
  {
    value: 'CascaderSelector',
    label: '多级选择器'
  },
  {
    value: 'SwitchItem',
    label: 'switch开关'
  },
  {
    value: 'ImageItem',
    label: '图片'
  },
  {
    value: 'DatePicker',
    label: '日期选择器'
  },
  {
    value: 'UploadSingleFileKit',
    label: '上传文件'
  }
]

// 日期选择类型
const dateSelectTypeList = [
  {
    value: 'date',
    label: '日期'
  },
  {
    value: 'month',
    label: '月份'
  },
  {
    value: 'year',
    label: '年份'
  },
  {
    value: 'daterange',
    label: '日期范围'
  },
  {
    value: 'monthrange',
    label: '月份范围'
  }
]

// 日期格式
const dateFormatList = [
  {
    value: 'YYYY-MM-DD',
    label: 'YYYY-MM-DD'
  },
  {
    value: 'YYYYMMDD',
    label: 'YYYYMMDD'
  },
  {
    value: 'YYYY-MM',
    label: 'YYYY-MM'
  },
  {
    value: 'YYYYMM',
    label: 'YYYYMM'
  },
  {
    value: 'YYYY',
    label: 'YYYY'
  }
]

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((visible).value = $event)),
    title: title.value,
    width: "80%",
    "close-on-click-modal": false,
    draggable: true
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: onCancel }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: onOk
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 12,
        class: "demo-radius",
        align: "middle",
        justify: "start"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: editingColumn.value.columnType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editingColumn.value.columnType) = $event)),
                class: "m-2",
                placeholder: "列类型",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columType, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.isExpand,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editingColumn.value.isExpand) = $event)),
                disabled: !(editingColumn.value.columnType==='normal' || editingColumn.value.columnType==='link'),
                label: "显示在扩展区",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.isLocalvalue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editingColumn.value.isLocalvalue) = $event)),
                disabled: !(editingColumn.value.columnType==='normal'),
                label: "锁定值",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.isRequired,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editingColumn.value.isRequired) = $event)),
                disabled: !(editingColumn.value.columnType==='normal'),
                label: "必填",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.actions.edit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editingColumn.value.actions.edit) = $event)),
                disabled: !(editingColumn.value.columnType==='action'),
                label: "编辑按钮",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: editingColumn.value.actions.editBtnName,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editingColumn.value.actions.editBtnName) = $event)),
                disabled: !(editingColumn.value.columnType==='action'),
                placeholder: '编辑按钮名称'
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.actions.delete,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editingColumn.value.actions.delete) = $event)),
                disabled: !(editingColumn.value.columnType==='action'),
                label: "删除按钮",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.isShowInAddDlg,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editingColumn.value.isShowInAddDlg) = $event)),
                disabled: !(editingColumn.value.columnType==='normal'),
                label: "是添加字段",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.isShowInEditDlg,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editingColumn.value.isShowInEditDlg) = $event)),
                disabled: !(editingColumn.value.columnType==='normal'),
                label: "显示在编辑窗口",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.disabledInEditDlg,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editingColumn.value.disabledInEditDlg) = $event)),
                disabled: !(editingColumn.value.columnType==='normal'),
                label: "在编辑窗口只读",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: editingColumn.value.placeholder,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editingColumn.value.placeholder) = $event)),
                disabled: !(editingColumn.value.columnType==='normal'),
                placeholder: '编辑框的placeholder'
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: editingColumn.value.tagInEditDlg,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editingColumn.value.tagInEditDlg) = $event)),
                class: "m-2",
                placeholder: "标签样式",
                style: {"width":"100%"},
                disabled: !(editingColumn.value.columnType==='normal')
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tagDefinedList, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: editingColumn.value.srcDataUrl,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editingColumn.value.srcDataUrl) = $event)),
                disabled: !(editingColumn.value.tagInEditDlg==='DropDownSelector' || editingColumn.value.tagInEditDlg==='UploadSingleFileKit' || editingColumn.value.tagInEditDlg==='CascaderSelector'),
                placeholder: '绑定数据源'
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.allowCreate,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((editingColumn.value.allowCreate) = $event)),
                disabled: !(editingColumn.value.tagInEditDlg==='DropDownSelector'),
                label: "下拉选择器是否允许创建",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: editingColumn.value.multiple,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editingColumn.value.multiple) = $event)),
                disabled: !(editingColumn.value.tagInEditDlg==='DropDownSelector'),
                label: "下拉选择器是否允许多选",
                size: "large"
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: editingColumn.value.pickerType,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((editingColumn.value.pickerType) = $event)),
                class: "m-2",
                placeholder: "日期选择类型",
                style: {"width":"100%"},
                disabled: !(editingColumn.value.tagInEditDlg==='DatePicker')
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dateSelectTypeList, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: editingColumn.value.valueFormat,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((editingColumn.value.valueFormat) = $event)),
                class: "m-2",
                placeholder: "日期格式",
                style: {"width":"100%"},
                disabled: !(editingColumn.value.tagInEditDlg==='DatePicker')
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dateFormatList, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})